//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem"],
  data() {
    return {
      isInforMation: false,
      showPicker: false,

      MessageDation: "",
      ThisName: "",
      ThisItem: {},

      DataList: [],
      ColumnNameList: []
    };
  },
  created() {
    if (
      this.controlItem &&
      this.controlItem.SelectDataList2 &&
      this.controlItem.SelectDataList2.length > 0
    ) {
      this.DataList = this.controlItem.SelectDataList2;
      this.ColumnNameList = this.controlItem.SelectDataList2.map(m => m.Text);

      var dataItem = this.controlItem.SelectDataList2.find(
        m => m.Value == this.controlItem.ControlValue
      );
      if (dataItem) {
        this.ThisName = dataItem.Text;
        this.ThisItem = dataItem;
      }
    }
  },

  methods: {
    onPickerClick() {
      this.showPicker = true;
    },

    onConfirm(value, index) {
      console.log(value);
      this.ThisName = value;
      this.ThisItem = null;

      if (index >= 0) {
        this.ThisItem = this.DataList[index];
        this.controlItem.ControlValue = this.ThisItem.Value;
      }
      console.log("this.ThisItem ", this.ThisItem);
      this.showPicker = false;

      if (this.ThisItem.Describe == null) {
        this.isInforMation = false;
        return;
      }

      this.MessageDation = "( 注：" + this.ThisItem.Describe + " )";
      this.isInforMation = true;
    }
  }
};
